import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import SurveyStepFooter from 'Views/Onboarding/Pages/Survey/SurveyStep/SurveyStepFooter';
import SurveyStepHeader from 'Views/Onboarding/Components/SurveyStepHeader';
import MetaFormFields from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/MetaFormFields';
import RemoveButton from 'Views/Onboarding/Pages/Survey/SurveyStep/Components/RemoveButton';
import { FDBox, FDStack } from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import FileUploadDropAreaWithAttachmentList
  from 'Components/ComponentLibrary/Molecules/FileUploadDropAreaWithAttachmentList';
import fr from 'facet-rest';
import { useSurveyContext } from 'Views/Onboarding/Pages/Survey/SurveyContext';
import useEventTrackingLogEvent from 'EventTracking/useEventTrackingLogEvent';
import { noop } from 'Helpers/PropTypes';
import useComponentDidMount from 'Hooks/useComponentDidMount';

const FILE_UPLOAD_ERROR_MESSAGE = 'Upload a pay stub to proceed';
function IncomeSalaryLayout() {
  const { refreshOnboardingStepCollection } = useSurveyContext();
  const { logEvent, logEventSuccess, logEventFailure } = useEventTrackingLogEvent({ nodeName: 'Income Salary onboarding step' });
  const {
    resource,
    onSubmit: onSubmitMetaForm,
    errors,
  } = useMetaLayoutContext();

  const logRelationshipEvent = (eventName, logEventFn = logEvent) => resource.withRelationship(
    fr.relationships.upload.name,
    (rel) => logEventFn(
      eventName,
      {
        relevantFeatureToggles: rel.meta('relevantFeatureToggles'),
      },
    ),
    noop,
  );

  const handleUploadComplete = (success) => {
    refreshOnboardingStepCollection();

    if (success) {
      logRelationshipEvent('Income Salary onboarding step pay stub upload success', logEventSuccess);
      return;
    }

    logRelationshipEvent('Income Salary onboarding step pay stub failure', logEventFailure);
  };

  useComponentDidMount(() => {
    logRelationshipEvent('Income Salary onboarding step loaded');
  });

  const needToUploadPayStubError = errors?.find((e) => e?.detail === FILE_UPLOAD_ERROR_MESSAGE);

  return (
    <FDBox>
      <SurveyStepHeader
        title={resource.attr('title')}
        subtitle={resource.attr('subtitle')}
      />
      <FDStack width={'100%'} direction={'column'} paddingY={2} spacing={2} alignItems={'center'}>
        <MetaControlField attr={'descriptionTitle'} />
        <MetaControlField attr={'description'} />
        {resource.withRelationship(fr.relationships.upload.name,
          (rel) => (
            <FDStack justifyContent={'center'} maxWidth={500} width={'100%'}>
              <FileUploadDropAreaWithAttachmentList
                trailingTitleText={'pay stubs'}
                subtitle={'JPG, PNG, PDF with max file size 50MB'}
                url={rel.link('related').url()}
                acceptedFileTypes="image/*,.pdf"
                attachments={resource.attr('payStubs').resources().list()}
                onSuccess={() => handleUploadComplete(true)}
                onError={() => handleUploadComplete(false)}
                onDelete={refreshOnboardingStepCollection}
                errorMessage={needToUploadPayStubError ? needToUploadPayStubError.detail : undefined}
                confirmOnDelete
              />
            </FDStack>
          ),
          () => null)}
      </FDStack>
      <MetaFormFields
        resource={resource}
      />
      {resource.meta().canDelete()
        && (<RemoveButton
          resource={resource}
          test="remove-item-button"
        />)
      }
      <SurveyStepFooter onSubmit={onSubmitMetaForm} />
    </FDBox>
  );
}

IncomeSalaryLayout.propTypes = {};

IncomeSalaryLayout.defaultProps = {};

export { IncomeSalaryLayout };
